/**
 * Nesse arquivo vamos criar algumas funções e constantes para definir campos obrigatórios
 * na compra com base no ERP utilizado.
 *
 * Isso será substituido futuramente por uma API que irá retornar essas informações.
 *
 * por enquanto vamos criar um mock para simular essa API, mas com os valores reais.
 * No futuro, podemos substituir esse arquivo pelas requests diretamente.
 */

/**
 * Aqui, podemos mapear os campos que serão bloqueados para edição
 * em cada ERP. Também podemos definir por entidade, caso seja necessário.
 * @type {{TOTVS: {campos: string[]}}}
 */
const ERP_CAMPOS_BLOQUEADOS_EDICAO = {
  TOTVS: {
    campos: ['comprador'],
  },
};

const ERP_CAMPOS_HIDDEN_MAP = {
  CASA_SHOPPING: {
    camposItens: ['centroCusto'],
  },
};

const ERP_CAMPOS_READONLY_MAP = {
  SENIOR_MEGA: {
    campos: ['centroCusto', 'projeto'],
    camposItens: ['centroCusto', 'projeto', 'cadastrosAdicionais'],
  },
};

const ERP_CAMPOS_OBRIGATORIOS_MAP = {
  SANKHYA: {
    campos: ['modoPagamento'],
  },
  SANKHYA_NORSIL: {
    campos: ['centroCusto', 'projeto', 'modoPagamento'],
    camposItens: ['centroCusto', 'projeto'],
  },
  SANKHYA_ART_LATEX: {
    campos: ['centroCusto', 'modoPagamento'],
    camposItens: ['centroCusto'],
  },
  M8: {
    campos: ['modoPagamento'],
  },
  PROJEDATA: {
    campos: ['modoPagamento', 'transportadora', 'tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  SENIOR_TEIXEIRA: {
    campos: ['modoPagamento', 'centroCusto'],
    camposItens: ['centroCusto'],
  },
  NEO: {
    campos: ['tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  TOTVS: {
    campos: ['modoPagamento'],
  },
  TOTVS_PROTHEUS: {
    campos: ['centroCusto'],
    camposIntens: ['centroCusto'],
  },
  M365_BUSCHE_LEPPER: {
    campos: ['tipoNotaEntrada', 'modoPagamento'],
    camposItens: ['tipoNotaEntrada'],
  },
  LM: {
    campos: ['modoPagamento'],
  },
  USEALL: {
    campos: ['modoPagamento'],
  },
  USEALL_SETUP: {
    campos: ['modoPagamento', 'projeto', 'centroCusto'],
    camposItens: ['projeto', 'centroCusto'],
  },
  FOCCO: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  USEALL_PROCER: {
    campos: ['centroCusto', 'modoPagamento'],
    camposItens: ['centroCusto'],
  },
  SENIOR_MEGA: {
    campos: ['centroCusto', 'projeto', 'modoPagamento'],
    camposItens: ['centroCusto', 'projeto'],
  },
  SENIOR_MEGA_SERPOL: {
    campos: ['centroCusto', 'projeto', 'modoPagamento'],
    camposItens: ['centroCusto', 'projeto'],
  },
  CASA_SHOPPING: {
    campos: ['centroCusto'],
  },
  NEO_GABRIELLA: {
    campos: ['tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  CIGAM: {
    campos: ['modoPagamento'],
  },
  SAP_B1: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  ELITE_SOFT: {
    campos: ['projeto', 'centroCusto'],
    camposItens: ['projeto', 'centroCusto'],
  },
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposObrigatorios = async (erpCamposIntegracao) => {
  const camposObrigatorios = ERP_CAMPOS_OBRIGATORIOS_MAP[erpCamposIntegracao];
  if (!camposObrigatorios) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposObrigatorios);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposReadonly = async (erpCamposIntegracao) => {
  const camposReadonly = ERP_CAMPOS_READONLY_MAP[erpCamposIntegracao];
  if (!camposReadonly) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposReadonly);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposHidden = async (erpCamposIntegracao) => {
  const camposHidden = ERP_CAMPOS_HIDDEN_MAP[erpCamposIntegracao];
  if (!camposHidden) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposHidden);
};

const getCamposBloqueadosEdicao = async (entidadeErp) => {
  const { idEntidade, erpCamposIntegracao } = entidadeErp;
  const camposBloquadosEntidade = ERP_CAMPOS_BLOQUEADOS_EDICAO[idEntidade];
  if (camposBloquadosEntidade) {
    return Promise.resolve(camposBloquadosEntidade);
  }
  const camposBloquados = ERP_CAMPOS_BLOQUEADOS_EDICAO[erpCamposIntegracao];
  if (!camposBloquados) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposBloquados);
};

export default {
  getCamposObrigatorios,
  getCamposReadonly,
  getCamposHidden,
  getCamposBloqueadosEdicao,
};
